import { plainToInstance } from 'class-transformer';
import { ReferenceDto } from '../dtos/reference.dto';

export function toReferenceDto(id: string, type: string): ReferenceDto {
  return plainToInstance(ReferenceDto, {
    id: id,
    type: type
  });
}
